import { getConfig } from '@local/app-config';
import { createApi } from '@reduxjs/toolkit/query/react';
import { getCurrentEvoInstance } from '../../store/sessionStorageHelpers/entitlementsHelper/entitlementsHelper';
import { createBentleyAccessTokenBaseQuery } from '../identityClient/requests/BentleyAccessTokenApi';
function getDiscoveryUrlConfig() {
    const currentHub = getCurrentEvoInstance();
    let url = '';
    if (currentHub.hub) {
        url = currentHub.hub.url + '/workspace';
    }
    else {
        url = getConfig().discovery_url;
    }
    return {
        url,
        forceOauthPrefix: false,
    };
}
export const BentleyEntitlementsApiClient = createApi({
    reducerPath: 'bentleyEntitlementsAPI',
    baseQuery: createBentleyAccessTokenBaseQuery(getDiscoveryUrlConfig),
    endpoints: () => ({}),
});
//# sourceMappingURL=BentleyEntitlementsApiClient.js.map